import './SelectInput.css';
import {forwardRef} from 'react';
import {classNames} from '../../utilities/classNames';
import {Icon} from '../Icon';

export const SelectInput = forwardRef<HTMLSelectElement, UI.SelectInput.Props>(function SelectInput(
  {className, tone, children, ...attributes},
  ref,
) {
  const classes = classNames('SelectInput', className, {
    'tone-default': tone == null || tone === 'default',
    'tone-danger': tone === 'danger',
    'tone-info': tone === 'info',
    'tone-neutral': tone === 'neutral',
    'tone-success': tone === 'success',
    'tone-warning': tone === 'warning',
    disabled: Boolean(attributes.disabled),
  });

  return (
    <div className={classes}>
      <select
        {...attributes}
        ref={ref}
        aria-invalid={attributes['aria-invalid'] ?? (tone === 'danger' ? true : undefined)}
        aria-required={attributes['aria-required'] ?? (attributes.required ? true : undefined)}
      >
        {children}
      </select>
      <div className="select-indicator" aria-hidden="true">
        <Icon name="arrow-down" size="sm" />
      </div>
    </div>
  );
});
